import { LOGIN_ROUTE } from './utils/routes'

export const AUTH0_PRODUCTION_DOMAIN = 'auth.estrack.com'
export const AUTH0_PRODUCTION_CLIENT_ID = 'YU792DKt0meL00W0lo3lvacARH7f2IvD'
export const AUTH0_PRODUCTION_AUDIENCE = 'https://api.equipmentshare.com'
export const AUTH_0_LOGOUT_URI = `${location.protocol}//${location.host}${LOGIN_ROUTE}`
export const AUTH_0_REDIRECT_URI = `${location.protocol}//${location.host}/`
export const AUTH0_STAGE_DOMAIN = 'staging-auth.estrack.com'
export const AUTH0_STAGE_CLIENT_ID = 'INNqwSlpbG97Urt2EJFF2jfaq2U61MeF'
export const AUTH0_STAGE_AUDIENCE = 'https://staging-api.equipmentshare.com'
export const PRODUCTION_HOST = 'aemp-integrations.estrack.com'
export const STAGING_HOST = 'staging-aemp-integrations.estrack.com'
export const STAGE_FEED_API_URL = 'https://stage-feed-api.internal.equipmentshare.com/api/v1'
export const FEED_API_URL = 'https://prod-feed-api.internal.equipmentshare.com/api/v1'
export const DATADOG_APPLICATION_ID = '6249583a-eabb-43b0-b44e-47953b9f9712'
export const DATADOG_CLIENT_TOKEN = 'pub3efe00021bc8e28489c70268f98a599b'
